export enum Industry {
  Restaurant = '餐飲業',
  CraftsAndAgriculturalProcessing = '傳統工藝與加工業',
  TourismAndAccommodation = '旅遊與住宿業',
  ExperienceActivitiesAndSightseeing = '體驗活動與觀光產業',
  Agriculture = '農業',
  AnimalHusbandry = '畜牧業',
  DevelopmentAssociationAndCommunity = '發展協會與社區',
}
